import ReactDOM from "react-dom/client";
import React from "react";
import "./index.css";
import {Provider} from "react-redux";
import store from "./Redux/store/store";

import App from "./App";


const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
